import script from "./ProcessUserDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProcessUserDetails.vue?vue&type=script&lang=ts&setup=true"

import "./ProcessUserDetails.vue?vue&type=style&index=0&id=04422014&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04422014"]])

export default __exports__